module.exports = __webpack_public_path__ + "static/img/p-29.ed50ee9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-29.png
// module id = 1TLA
// module chunks = 0